(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["aurea-product"]) return;
  try {
    
async function addDarItem(form) {
  const feedback = form.querySelector('[data-cart-feedback]');
  if (!feedback) return;
  if (form.dataset.pending === 'true') return;
  const button = form.querySelector('[data-au-add]');
  const message = feedback.querySelector('[data-cart-message]');
  const cartLink = feedback.querySelector('[data-cart-link]');
  form.dataset.pending = 'true';
  button.disabled = true;
  form.setAttribute('aria-busy', 'true');
  message.textContent = feedback.dataset.adding;
  cartLink.hidden = true;
  const cartRoot = cartLink.getAttribute('href').replace(/\/cart$/, '/');
  let added = false;
  try {
    const response = await fetch(cartRoot + 'cart/add.js', {method: 'POST', body: new FormData(form), headers: {'Accept': 'application/json'}});
    const result = await response.json();
    if (!response.ok) throw new Error(result.description || feedback.dataset.error);
    added = true;
    message.textContent = feedback.dataset.added;
    cartLink.hidden = false;
    const cartResponse = await fetch(cartRoot + 'cart.js', {headers: {'Accept': 'application/json'}});
    if (cartResponse.ok) {
      const cart = await cartResponse.json();
      const cartAnchor = document.querySelector('.ev-cart-link');
      if (cartAnchor) {
        let count = cartAnchor.querySelector('.ev-cart-count');
        if (!count) { count = document.createElement('span'); count.className = 'ev-cart-count'; cartAnchor.append(count); }
        count.textContent = String(cart.item_count);
      }
    }
  } catch (error) {
    if (!added) message.textContent = error.message || feedback.dataset.error;
  } finally {
    delete form.dataset.pending;
    form.removeAttribute('aria-busy');
    button.disabled = false;
  }
}
document.addEventListener('click', (event) => {
  const button = event.target.closest('[data-au-add]');
  if (!button || !button.closest('.au-buy-form')) return;
  event.preventDefault();
  event.stopPropagation();
  addDarItem(button.closest('.au-buy-form'));
}, true);
document.addEventListener('submit', (event) => {
  if (!event.target.matches('.au-buy-form')) return;
  event.preventDefault();
  event.stopPropagation();
  addDarItem(event.target);
}, true);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
